import svgForEverybody from 'svg4everybody';
import { StringService } from '../string';
import { DomService } from '../dom';
import { svgs, dimensions, SvgType } from './icons';

export type { SvgType };

svgForEverybody();

export const SvgService = {
  getTypes(): readonly SvgType[] {
    return svgs;
  },

  isSvg: (icon: SvgType): boolean => SvgService.getTypes().indexOf(icon) >= 0,

  getSvg(id: SvgType, style?: Partial<CSSStyleDeclaration>, basePath = './', ariaLabel?: string): string {
    if (!SvgService.isSvg(id)) {
      return '';
    }

    const url = `/static/svg/icons/${id}.svg`;
    const { width, height } = dimensions[id];

    const inlineStyle: Partial<CSSStyleDeclaration> = { ...(style || {}) };

    if (inlineStyle.width && !inlineStyle.height) {
      inlineStyle.height = `calc(${inlineStyle.width} * ${height / width})`;
    } else if (inlineStyle.height && !inlineStyle.width) {
      inlineStyle.width = `calc(${inlineStyle.height} * ${width / height})`;
    }

    const inline: string[] = [];
    Object.keys(inlineStyle).forEach((key): void => {
      inline.push(`${StringService.camelToKebab(key)}:${inlineStyle[key]}`);

      if (key === 'width' || key === 'height') {
        inline.push(`min-${key}:${inlineStyle[key]}`);
      }
    });

    const container = DomService.createElement(
      'div',
      `
      <svg xmlns="http://www.w3.org/2000/svg" ${ariaLabel ? `aria-label="${ariaLabel}"` : ''}>
        <use href="${url}#${id}">
      </svg>
    `,
    );

    if (inline.length) {
      container.children[0].setAttribute('style', inline.join(';'));
    }
    return container.innerHTML;
  },
};
